const IMAGE_EXTENSION_PATTERN = /\.(gif|jpe?g|tiff|png|bmp|webp|avif|svg)$/i;

/** Matches image preview logic in file-upload (mime type or file name). */
export function isImageContentType(
  contentType: string | undefined,
  fileName?: string
): boolean {
  if (contentType) {
    if (/^image\//i.test(contentType)) return true;
    if (/(gif|jpg|jpeg|tiff|png|bmp|webp|avif)$/i.test(contentType)) {
      return true;
    }
  }

  if (fileName) {
    return IMAGE_EXTENSION_PATTERN.test(fileName);
  }

  return false;
}

/** True when a URL points at an image asset (S3 path extension or data URI). */
export function isImageFileUrl(url: string | undefined): boolean {
  if (!url) return false;
  if (url.startsWith("data:image/")) return true;

  const path = url.split("?")[0].split("#")[0];
  return IMAGE_EXTENSION_PATTERN.test(path);
}
